import React, { useContext, useMemo, useState } from 'react';
import get from 'lodash/get';
import set from 'lodash/set';
import styled from 'styled-components';

import { StyledRadioGroup } from 'src/presentation/components/pages/channels/shared/setupPhoneModal/templates/shared/elements';
import FormContext from 'src/presentation/contexts/FormContext';

type PickOmitProps = {
  attr: string;
  disabled: boolean;
};

const PickOmitValues = ['omitItems', 'includeItems'];

const PickOmit = ({ attr, disabled }: PickOmitProps) => {
  const { workingState, onBlur } = useContext(FormContext);

  const key = useMemo(() => {
    const keys = get(workingState, attr, {});
    if (Object.keys(keys).length && PickOmitValues.includes(Object.keys(keys)[0])) {
      return Object.keys(keys)[0];
    }
    return PickOmitValues[0];
  }, [workingState, attr]);

  const [value, setValue] = useState(key);

  const handleChanges = ev => {
    const val = ev.target.value;

    const currentState = set(workingState, attr, { [val]: true });

    onBlur && onBlur({ currentState, needToOverrideState: true });
    setValue(val);
  };

  return (
    <RadioGroupWrapper>
      <StyledRadioGroup
        className="radioGroup"
        attr="activateSms"
        onChange={handleChanges}
        value={value}
        disabled={disabled}
        options={[
          {
            label: 'Omit these items',
            value: 'omitItems',
          },
          {
            label: 'Include these items',
            value: 'includeItems',
          },
        ]}
      />
    </RadioGroupWrapper>
  );
};

const RadioGroupWrapper = styled.div`
  margin-top: 10px;
`;

export default PickOmit;
